<template>
  <div class="container-withdraw-account" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.WithdrawalAccount.k033') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现国家 -->
      <div class="select">
        <span>{{ $t('lang.BaseModule.k015') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <!-- 印尼 -->
      <template v-if="locaCode === 'ID'">
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k021') }}</span>
          <van-field v-model="bankText" is-link readonly label="" :placeholder="$t('lang.WithdrawalAccount.k021')" @click="showBankPicker = true" />
        </div>
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k020') }}</span>
          <input type="number" :placeholder="$t('lang.WithdrawalAccount.k020')" @input="customMaxLen($event, 11, 'accountId')" v-model="accountId" />
        </div>
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k013') }}</span>
          <input type="text" maxlength="20" :placeholder="$t('lang.WithdrawalAccount.k028')" v-model.trim="accountName" />
        </div>
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k029') }}</span>
          <div class="phone-number-wrapper">
            <span class="area-wrapper">+62</span>
            <div class="account-line"></div>
            <input
              type="number"
              :placeholder="`${$t('lang.WithdrawalAccount.k029')}（eg:12345678910）`"
              v-model="userPhoneNumber"
              @input="customMaxLen($event, 14, 'userPhoneNumber')"
            />
          </div>
        </div>
      </template>

      <!-- 摩洛哥 -->
      <template v-else-if="locaCode === 'MA'">
        <div class="select">
          <span>{{ $t('lang.BaseModule.k041') }}</span>
          <input type="text" :placeholder="$t('lang.BaseModule.k041')" v-model.trim="accountName" />
        </div>
        <div class="select">
          <span>{{ $t('lang.BaseModule.k001') }}</span>
          <input type="text" maxlength="24" :placeholder="$t('lang.WithdrawalAccount.k011')" v-model="accountId" />
        </div>
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k021') }}</span>
          <van-field v-model="bankText" is-link readonly label="" :placeholder="$t('lang.WithdrawalAccount.k021')" @click="showBankPicker = true" />
        </div>
      </template>

      <!-- 越南 -->
      <template v-else-if="locaCode === 'VN'">
        <div class="select">
          <span>{{ $t('lang.BaseModule.k041') }}</span>
          <input type="text" :placeholder="$t('lang.BaseModule.k041')" v-model.trim="accountName" />
        </div>
        <div class="select">
          <span>{{ $t('lang.BaseModule.k001') }}</span>
          <input type="text" maxlength="19" :placeholder="$t('lang.WithdrawalAccount.k011')" v-model="accountId" />
        </div>
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k029') }}</span>
          <input
            type="number"
            :placeholder="`${$t('lang.WithdrawalAccount.k029')}（eg:1234567890）`"
            v-model="userPhoneNumber"
            @input="customMaxLen($event, 10, 'userPhoneNumber')"
          />
        </div>
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k021') }}</span>
          <van-field v-model="bankText" is-link readonly label="" :placeholder="$t('lang.WithdrawalAccount.k021')" @click="showBankPicker = true" />
        </div>
      </template>

      <!-- 土耳其 -->
      <template v-else-if="locaCode === 'TR'">
        <div class="select">
          <span>{{ $t('lang.BaseModule.k041') }}</span>
          <input type="text" maxlength="50" :placeholder="$t('lang.BaseModule.k041')" v-model.trim="accountName" />
        </div>
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k029') }}</span>
          <input
            type="number"
            :placeholder="$t('lang.WithdrawalAccount.k029')"
            v-model="userPhoneNumber"
            @input="customMaxLen($event, 15, 'userPhoneNumber')"
          />
        </div>
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k045') }}</span>
          <input type="email" maxlength="100" :placeholder="$t('lang.WithdrawalAccount.k052')" v-model.trim="userEmail" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
        </div>
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k021') }}</span>
          <van-field v-model="bankText" is-link readonly label="" :placeholder="$t('lang.WithdrawalAccount.k021')" @click="showBankPicker = true" />
        </div>
        <div class="select">
          <span>{{ $t('lang.WithdrawalAccount.k046') }}</span>
          <input type="text" maxlength="30" :placeholder="$t('lang.WithdrawalAccount.k046')" v-model="accountId" />
          <p class="iban-tip">{{ $t('lang.WithdrawalAccount.k047') }}</p>
        </div>
      </template>

      <!-- 其他 -->
      <template v-else>
        <div class="select">
          <span>{{ $t('lang.BaseModule.k041') }}</span>
          <input type="text" :placeholder="$t('lang.BaseModule.k041')" v-model.trim="accountName" />
        </div>
        <div class="select">
          <span>{{ $t('lang.BaseModule.k001') }}</span>
          <input type="text" maxlength="24" :placeholder="$t('lang.WithdrawalAccount.k011')" v-model="accountId" />
        </div>
      </template>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'forbid-submit': this.submitBtnStatus() }" @click="handleSave">
        {{ $t('lang.BaseModule.k051') }}
      </div>
    </div>

    <!-- 选择银行弹窗 -->
    <van-popup v-model="showBankPicker" destroy-on-close round position="bottom">
      <van-picker
        show-toolbar
        :key="locaCode"
        :cancel-button-text="$t('lang.BaseModule.k067')"
        :confirm-button-text="$t('lang.BaseModule.k069')"
        :model-value="pickerValue"
        :columns="bankList"
        @cancel="showBankPicker = false"
        @confirm="handleBankPickerConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'
import { isEmail } from '@/utils/common.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

export default {
  mixins: [baseMixin],
  data() {
    return {}
  },
  methods: {
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          // lang.WithdrawalAccount.k036: "Does not support emoji input"
          this.$client.showToast(this.$t('lang.WithdrawalAccount.k036'))
          return
        }

        // 银行
        if (this.bankType.includes(this.withdrawalMethod)) {
          // 摩洛哥
          if (this.locaCode === 'MA') {
            if (this.accountId.length < 24) {
              // lang.WithdrawalAccount.k038: "Wrong format. Please enter an {n0} digit number"
              this.$client.showToast(this.replaceOneText(this.$t('lang.WithdrawalAccount.k038'), '{n0}', '24'))
              return
            }
            if (!this.bankCode) {
              // lang.WithdrawalAccount.k035: "Please select a bank"
              this.$client.showToast(this.$t('lang.WithdrawalAccount.k035'))
              return
            }
          }

          // 印尼
          if (this.locaCode === 'ID') {
            if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber) {
              // lang.WithdrawalAccount.k044: "Please fill in the complete information"
              this.$client.showToast(this.$t('lang.WithdrawalAccount.k044'))
              return
            }
            if (`${this.userPhoneNumber}`.length < 10 || `${this.userPhoneNumber}`.length > 14) {
              // lang.WithdrawalAccount.k038: "Wrong format. Please enter an {n0} digit number"
              this.$client.showToast(this.replaceOneText(this.$t('lang.WithdrawalAccount.k038'), '{n0}', '10~14'))
              return
            }
            if (`${this.accountId}`.length !== 11) {
              // lang.WithdrawalAccount.k038: "Wrong format. Please enter an {n0} digit number"
              this.$client.showToast(this.replaceOneText(this.$t('lang.WithdrawalAccount.k038'), '{n0}', '11'))
              return
            }
          }

          // 越南
          if (this.locaCode === 'VN') {
            if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber) {
              // lang.WithdrawalAccount.k044: "Please fill in the complete information"
              this.$client.showToast(this.$t('lang.WithdrawalAccount.k044'))
              return
            }
            if (`${this.userPhoneNumber}`.length !== 10) {
              // lang.WithdrawalAccount.k038: "Wrong format. Please enter an {n0} digit number"
              this.$client.showToast(this.replaceOneText(this.$t('lang.WithdrawalAccount.k038'), '{n0}', '10'))
              return
            }
            if (`${this.accountId}`.length < 16 || `${this.accountId}`.length > 19) {
              // lang.WithdrawalAccount.k038: "Wrong format. Please enter an {n0} digit number"
              this.$client.showToast(this.replaceOneText(this.$t('lang.WithdrawalAccount.k038'), '{n0}', '16~19'))
              return
            }
          }

          // 土耳其
          if (this.locaCode === 'TR') {
            if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber || !this.userEmail) {
              // lang.WithdrawalAccount.k044: "Please fill in the complete information"
              this.$client.showToast(this.$t('lang.WithdrawalAccount.k044'))
              return
            }
            if (!isEmail(this.userEmail)) {
              // lang.WithdrawalAccount.k052: "Please enter a valid email"
              this.$client.showToast(this.$t('lang.WithdrawalAccount.k052'))
              return
            }
          }
        }

        const data = {
          accountName: this.accountName,
          accountId: this.accountId,
        }

        if (this.bankType.includes(this.withdrawalMethod)) {
          data.bankCode = this.bankCode
          // 印尼 越南
          if (['ID', 'VN'].includes(this.locaCode)) {
            data.phoneNumber = this.userPhoneNumber
          }
          // 土耳其
          if (this.locaCode === 'TR') {
            data.phoneNumber = this.userPhoneNumber
            data.email = this.userEmail
          }
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              this.jumpWithdrawal()
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              this.jumpWithdrawal()
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false,
      }
    ),
    // 保存校验
    submitBtnStatus() {
      if (this.bankType.includes(this.withdrawalMethod)) {
        // 摩洛哥
        if (this.locaCode === 'MA') {
          if (!this.bankCode || !this.accountId || !this.accountName) {
            return false
          }
        }

        // 印尼
        if (this.locaCode === 'ID') {
          if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber) {
            return false
          }
        }

        // 越南
        if (this.locaCode === 'VN') {
          if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber) {
            return false
          }
        }

        // 土耳其
        if (this.locaCode === 'TR') {
          if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber || !this.userEmail) {
            return false
          }
        }

        return true
      }

      return false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../base.scss';
</style>
